export const getStyleFromCSSModule = (className: string) => {
  const stylesheets = Array.from(document.styleSheets);
  const inlineStyles: { [key: string]: string } = {};

  stylesheets.forEach((sheet) => {
    try {
      const rules = sheet.cssRules || [];
      if (!rules) {
        return;
      }
      Array.from(rules).forEach((rule) => {
        const cssRule = rule as CSSStyleRule;
        if (cssRule.selectorText === `.${className}`) {
          const style = cssRule.style;
          Array.from(style).forEach((prop: string) => {
            inlineStyles[prop] = style.getPropertyValue(prop);
          });
        }
      });
    } catch (e) {
      console.warn("Error accessing stylesheet rules:", e);
    }
  });

  return inlineStyles;
};

export const toCamelCase = (str: string) => {
  return str
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase()
    )
    .replace(/\s+/g, " ");
};

export const getResponsiveBgImage = (images: string[] | undefined) => {
  if (images == undefined) return;
  const ratio = window.devicePixelRatio;

  if (ratio >= 3 && images[2]) return images[2];
  if (ratio >= 2 && images[1]) return images[1];
  return images[0]; // fallback to 1x
};
